import * as React from "react";
import PropTypes from "prop-types";

import PopoverPortal from "./PopoverPortal";

export interface Props {
  name?: string;
}

class PopoverPortalProvider extends React.Component<Props> {
  public static childContextTypes = {
    popoverPortalName: PropTypes.string,
  };

  public getChildContext() {
    return {
      popoverPortalName: this.getPortalName(),
    };
  }

  public getPortalName() {
    // TODO: Generate and persist random name
    return this.props.name || "some-portal-name";
  }

  public render() {
    return (
      <>
        {this.props.children}
        <PopoverPortal name={this.getPortalName()} />
      </>
    );
  }
}

export default PopoverPortalProvider;



// WEBPACK FOOTER //
// ./frontend/src/common/components/popover/PopoverPortalProvider.tsx